import { render } from "./BanobagiStatsGrid.vue?vue&type=template&id=35efa1c6&scoped=true"
import script from "./BanobagiStatsGrid.vue?vue&type=script&lang=js"
export * from "./BanobagiStatsGrid.vue?vue&type=script&lang=js"

import "./BanobagiStatsGrid.vue?vue&type=style&index=0&id=35efa1c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35efa1c6"]])

export default __exports__